import { gsap } from "./gsapSetup";

export function initServiceTilesHover() {
  const tiles = document.querySelectorAll(".service-tile");
  if (!tiles.length) return;

  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  tiles.forEach((tile) => {
    const bg = tile.querySelector(".service-tile__bg");
    const icon = tile.querySelector(".service-tile__icon");
    const svg = tile.querySelector(".service-tile__svg");

    const titles = gsap.utils.toArray(tile.querySelectorAll(".service-tile__title"));
    const texts  = gsap.utils.toArray(tile.querySelectorAll(".service-tile__text"));

    if (!bg) return;

    // make sure GSAP owns transforms (even if you set -translate-x in Tailwind)
    gsap.set(bg, { xPercent: -110 });

    const hoverBg = tile.dataset.hoverBg || "#9F58EB"; // blue
    const hoverText = tile.dataset.hoverText || "#FFFFFF";
    const hoverTitle = tile.dataset.hoverTitle || "#FFFFFF";
    const hoverIconBg = tile.dataset.hoverIconBg || "#FFFFFF"; // "rgba(255,255,255,0.15)";

    const tlIn = gsap.timeline({ paused: true })
      .to(bg, { backgroundColor: hoverBg, xPercent: 0, duration: 0.45, ease: "power3.out", }, 0);

    if (texts.length) {
      tlIn.to(texts, { color: hoverText, duration: 0.45, ease: "power3.out", }, 0.1);
    }
    if (titles.length) {
      tlIn.to(titles, { color: hoverTitle, duration: 0.45, ease: "power3.out", }, 0.1);
    }
    if (icon) {
      tlIn.to(icon, { backgroundColor: hoverIconBg, duration: 0.45, ease: "power3.out", }, 0.1);
    }
    if (svg) {
      tlIn.to(svg, { color: hoverBg, duration: 0.2, ease: "none", }, 0.1);
    }

    const playIn = () => tlIn.restart();

    const playOut = () => {
      tlIn.kill();

      gsap.to(bg, {
        xPercent: 210,
        duration: 0.45,
        ease: "power3.in",
        onComplete: () => gsap.set(bg, { xPercent: -110 }),
      });

      // restore Tailwind styles
      if (titles.length || texts.length) {
        gsap.set([...titles, ...texts], { clearProps: "color" });
      }
      if (svg) gsap.set(svg, { clearProps: "color" });
      if (icon) gsap.set(icon, { clearProps: "backgroundColor" });
      gsap.set(tile, { clearProps: "borderColor" });
    };

    if (prefersReduced) {
      tile.addEventListener("mouseenter", () => {
        gsap.set(bg, { backgroundColor: hoverBg, xPercent: 0 });
        gsap.set(titles, { color: hoverTitle });
        gsap.set(texts, { color: hoverText });
        if (icon) gsap.set(icon, { backgroundColor: hoverIconBg });
        if (svg) gsap.set(svg, { color: hoverBg });
      });

      tile.addEventListener("mouseleave", () => {
        gsap.set(bg, { xPercent: -110 });
        gsap.set([...titles, ...texts], { color: "" });
        if (icon) gsap.set(icon, { backgroundColor: "" });
        if (svg) gsap.set(svg, { color: "" });
      });

      return;
    }

    tile.addEventListener("mouseenter", playIn);
    tile.addEventListener("mouseleave", playOut);
  });
}

export default function initServiceCardHover() {
  const cards = document.querySelectorAll(".service-card");
  if (!cards.length) return;

  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  cards.forEach((card) => {
    const bg = card.querySelector(".service-card__bg");
    const title = card.querySelector(".service-card__title");
    const text = card.querySelector(".service-card__text");
    const cta = card.querySelector(".service-card__cta");

    // only bg + title are required
    if (!bg || !title) return;

    const textTargets = [title, text].filter(Boolean); // circle layout: only title

    // Initial state (your CSS already hides it, but we force it too)
    gsap.set(bg, { yPercent: -110 });
    gsap.set(textTargets, { color: "" });

    if (cta) gsap.set(cta, { backgroundColor: "transparent", color: "" });

    const tlIn = gsap.timeline({ paused: true })
      .to(bg, { yPercent: 0, duration: 0.45, ease: "power3.out" }, 0)
      .to(card, { borderColor: "rgba(254,117,135,1)", duration: 0.25, ease: "power2.out" }, 0)
      .to(textTargets, { color: "#ffffff", duration: 0.2, ease: "none" }, 0.1);

    // CTA exists only in the first layout
    if (cta) {
      tlIn
        .to(cta, { backgroundColor: "#ffffff", duration: 0.2, ease: "none" }, 0.1)
        .to(cta, { color: "#0B1422", duration: 0.2, ease: "none" }, 0.1);
    }

    const playIn = () => tlIn.restart();

    const playOut = () => {

      tlIn.kill();

      gsap.to(bg, {
        yPercent: 210,
        duration: 0.45,
        ease: "power3.in",
        onComplete: () => gsap.set(bg, { yPercent: -110 }),
      });

      gsap.to(card, {
        borderColor: "rgba(0,0,0,0.10)",
        duration: 0.25,
        ease: "power2.out",
      });

      gsap.to(title, { color: "", duration: 0.2, ease: "none" });
      if (text) gsap.to(text, { color: "", duration: 0.2, ease: "none" });

      if (cta) {
        gsap.to(cta, { backgroundColor: "transparent", color: "", duration: 0.2, ease: "none" });
      }
    };

    if (prefersReduced) {
      card.addEventListener("mouseenter", () => {
        gsap.set(bg, { yPercent: 0 });
        gsap.set(textTargets, { color: "#fff" });
        if (cta) gsap.set(cta, { backgroundColor: "#fff", color: "#0B1422" });
      });

      card.addEventListener("mouseleave", () => {
        gsap.set(bg, { yPercent: -110 });
        gsap.set(textTargets, { color: "" });
        if (cta) gsap.set(cta, { backgroundColor: "transparent", color: "" });
      });
      return;
    }

    card.addEventListener("mouseenter", playIn);
    card.addEventListener("mouseleave", playOut);
  });
}
